import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=499b8a49"
import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499b8a49')) {
      api.createRecord('499b8a49', component.options)
    } else {
      api.reload('499b8a49', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=499b8a49", function () {
      api.rerender('499b8a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/Layout.vue"
export default component.exports